
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glaci",
      function () {
        return require("private-next-pages/glaci/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glaci"])
      });
    }
  